import React from 'react'
import useEyeDropper from 'use-eye-dropper'
import { PickIcon } from '../../../images/common'
import './PickerEyeDrop.scss'
import tinycolor from 'tinycolor2'

const PickerEyeDrop = ({ mode = 1, onOpen, onChange, disabled, alpha = 1 }) => {
  const { open } = useEyeDropper()

  const handleClick = async () => {
    if (disabled) return
    if (mode === 2) {
      if (onOpen) onOpen()
      return
    }
    try {
      const result = await open()
      const tc = tinycolor(result.sRGBHex)

      if (onChange) {
        const updatedRgb = { ...tc.toRgb(), a: alpha }
        const tcWithAlpha = tinycolor(updatedRgb)
        onChange({
          hex: tcWithAlpha.toHex8String(),
          rgb: updatedRgb,
          hsl: tcWithAlpha.toHsl(),
          hsv: tcWithAlpha.toHsv()
        })
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className='viso-color-picker-eyedrop'>
      <button onClick={handleClick} className='viso-color-picker-eyedrop__button' disabled={disabled}>
        <PickIcon />
      </button>
    </div>
  )
}

export default PickerEyeDrop
